import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { generateQueryString } from '../../utils/functions';
import queryString from 'query-string';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Button, Popover, Modal } from 'antd';
import { ActionDeleteById } from '../../store/Actions/CommonAction';
import { matchPermissions } from '../../utils/Permission';
import { TableListPageCom } from '../../components/TableListPageCom';
import { GetAllPatientTestimonial } from '../../store/Actions/TestimonialLinkAction';
import { DOCS_URL } from '../../utils/globals';

const PatientTestimonialList = () => {
  const { confirm } = Modal;
  const pageSize = 10;
  const dispatch = useDispatch();
  const { PatientTestimonialList, loader } = useSelector(state => state?.TestimonialLink);
  const { userDetails } = useSelector(state => state?.auth);
  const url = new URL(window.location.href);
  const searchParams = url.searchParams;
  const page = searchParams.get('page');
  const patientName = searchParams.get('patientName');
  const Final = generateQueryString(['page', page || 1], ['patientName', patientName]);
  const params = queryString.parse(location.search);
  useEffect(() => {
    dispatch(GetAllPatientTestimonial({ Query: Final }));
  }, []);

  const matchPermissionsForUser = matchPermissions(userDetails);
  const canUpdate = matchPermissionsForUser('patient-testimonial.update');
  const canDelete = matchPermissionsForUser('patient-testimonial.delete');

  const content = item => (
    <div className="row col">
      {canUpdate && (
        <Button
          className="col m-2"
          onClick={() => {
            window.location.href = `/add-patient-testimonial?update=true&&page=${page}&&id=${item?.id}`;
          }}
        >
          Edit Patient Testimonial
        </Button>
      )}
      {canDelete && (
        <Button className="col m-2" onClick={() => showDeleteConfirm(item)}>
          Delete Patient Testimonial
        </Button>
      )}
    </div>
  );

  const showDeleteConfirm = item => {
    confirm({
      title: `Are you sure delete this ${item?.patientName}?`,
      icon: <ExclamationCircleFilled />,
      content: '',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      zIndex: 1200,
      centered: true,
      onOk() {
        dispatch(
          ActionDeleteById({ Query: `admin/patient-testimonial/${item?._id}` }, Res => {
            if (Res?.statusCode === 200) {
              //setRefresh(true)
              window.location.reload();
            }
          })
        );
      },
      onCancel() {},
    });
  };
  const columns = [
    {
      title: 'Sr',
      dataIndex: 'sr',
      render: (text, record, index) => {
        const currentPage = parseInt(params?.page) || 1;
        const calculatedIndex = (currentPage - 1) * pageSize + index + 1;
        return <span>{calculatedIndex}</span>;
      },
    },
    {
      title: 'Patient Name',
      dataIndex: 'patientName',
    },
    {
      title: 'Age',
      dataIndex: 'age',
    },
    {
      title: 'Treatments',
      dataIndex: 'treatment',
      render: treatment => {
        if (treatment && treatment.length > 0) {
          return treatment.map(item => item.treatmentName).join(', ');
        }
        return null;
      },
    },
    {
      title: 'Description',
      dataIndex: 'description',
    },
    {
      title: 'Rating',
      dataIndex: 'rating',
    },
    {
      title: 'Images',
      dataIndex: 'docs',
      render: (text, record) => (
        <img src={DOCS_URL + record.docs} alt={record.name} style={{ width: 60, height: 60 }} />
      ),
    },
    {
      title: !canUpdate && !canDelete ? null : 'Action',
      dataIndex: 'roleName',
      render: (text, record) => {
        if (!canUpdate && !canDelete) {
          return null;
        } else {
          return (
            <Popover placement="top" title={text} content={() => content(record)}>
              <Button type="text">• • •</Button>
            </Popover>
          );
        }
      },
    },
  ];

  const BreadcrumbList = [
    {
      name: 'Patient Testimonial',
      linkTo: `/patient-testimonial-list?page=${params?.page || 1}`,
    },
    {
      name: 'Patient Testimonial List',
    },
  ];

  return (
    <TableListPageCom
      BreadcrumbList={BreadcrumbList}
      TableData={PatientTestimonialList?.docs}
      TableColumn={columns}
      ShowAddButton={matchPermissions(userDetails)}
      Iscreate="patient-testimonial.create"
      CreateButtonLink={`/add-patient-testimonial?update=false&&page=${params?.page || 1}`}
      PageMainTitle="Patient Testimonial List"
      CurrentPage={PatientTestimonialList?.page || 1}
      Tableloader={loader}
      TotalPageList={PatientTestimonialList?.totalDocs}
      dataSourceLength={PatientTestimonialList?.docs?.length}
      handlePageChange={v => {
        var newp = params;
        newp.page = v;
        window.location.href = window.location.pathname + '?' + queryString.stringify(newp);
      }}
    />
  );
};

export default PatientTestimonialList;
